import { createSwiperWithPagination } from './utils/swiperFactory.js';
import { initScheduleSlider } from './utils/scheduleSlider.js';

// ★ SCHEDULE：ユーティリティ化した初期化関数を呼ぶだけ
window.swiperScheduleSlider = initScheduleSlider(
    '.schedule-slider',
    '.schedule-slider-next',
    '.schedule-slider-prev',
    {
        // ここに必要ならオプション上書き（例）
        // speed: 1200,
        // breakpoints: { 1280: { slidesPerView: 4 } }
    }
);

document.addEventListener('DOMContentLoaded', () => {

    // HERO セクションのスライダー
    window.swiperHeroSlider = createSwiperWithPagination(
        '.event-poster-swiper',
        '.event-poster-swiper .swiper-pagination',
        {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {crossFade: true},
            observer: true,
            observeParents: true
        }
    );
});
